import { Link } from "react-router-dom";
import { useT } from "@/lib/i18n";

const BADGE_CLASSES = {
  "Best seller": "gv-badge gv-badge--bestseller",
  "New": "gv-badge gv-badge--new",
  "Popular": "gv-badge gv-badge--popular",
};

export const ProductCard = ({ product, size = "md" }) => {
  const t = useT();
  const aspect = size === "lg" ? "aspect-[3/4]" : "aspect-[3/4]";
  return (
    <Link
      to={`/product/${product.slug}`}
      className="map-card group relative bg-white rounded-[5px] overflow-hidden border border-[color:var(--gv-line)] block"
      data-testid={`product-card-${product.slug}`}
    >
      {product.badge && (
        <span className={`absolute top-3 left-3 z-10 ${BADGE_CLASSES[product.badge] || "gv-badge gv-badge--popular"}`}>
          {product.badge}
        </span>
      )}
      <div className={`${aspect} overflow-hidden bg-[color:var(--gv-mist)]`}>
        <img src={product.image} alt={`${product.name}`} loading="lazy" className="w-full h-full object-cover" />
      </div>
      <div className="p-4 md:p-5">
        <div className="text-[11px] uppercase tracking-widest text-[color:var(--gv-ink)]/50 mb-1.5">
          {product.country}
        </div>
        <h3 className="font-display text-[16px] md:text-[18px] text-[color:var(--gv-ink)] leading-snug mb-2 group-hover:text-[color:var(--gv-pink)] transition-colors line-clamp-2">
          {product.name}
        </h3>
        <div className="text-[13px] text-[color:var(--gv-blue)] font-medium">{t("common.from")} €{product.priceFrom}</div>
      </div>
    </Link>
  );
};

export default ProductCard;
